import { useQuery } from '@tanstack/react-query'
import { StorageKey } from '@/client/types'
import { getStates } from '@/infra/services'

export const useGetStates = (countryId: string = '') =>
  useQuery({
    queryKey: [StorageKey.STATES, countryId],
    queryFn: () => getStates(countryId),
    enabled: !!countryId,
    refetchOnWindowFocus: false
  })
